export default __webpack_public_path__ + "static/5-8277bef4a1cf8b24e4ec19e9d6ca9169.png";